import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {contentCardSchema} from '../../../../../schemas/contentCardSchema';
import {z} from 'zod';
import {ContentFeedNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {TimezoneSource} from 'common/src/modules/timezones/timezones.types';
import {FeedColumn} from 'common/src/modules/relatedItems/relatedItems.types';
import {DefaultCardOutputs} from '../../utils/convertCardSchemaToCard/convertCardSchemaToCard.consts';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

export function convertContentAICardToAPICard(
  contentCard: z.input<typeof contentCardSchema>,
  existingCard: ContentFeedNode,
): ContentFeedNode {
  const outputs = existingCard ? existingCard.outputs : DefaultCardOutputs;

  return {
    ...getAICardBaseDetails(contentCard),
    type: NodeType.CONTENT_FEED,
    outputs,
    ...(contentCard.conditions
      ? {
          configuration: {
            conditions: contentCard.conditions,
            orderBy: FeedColumn.id,
            contentType: 0,
          },
        }
      : {configuration: null}),
    contentId: contentCard.contentId,
    contentFeedId: contentCard.contentFeedId ?? 0,
    contentSetId: contentCard.contentSetId ?? 0,
    strategy: contentCard.strategy,
    timezoneSource: TimezoneSource.User,
    timeZone: 'America/New_York',
  } as ContentFeedNode;
}
